<template>
	<div class="login-box" @keydown.enter="keydownMethod">
		<div class="login-content">
			<div class="login-left">
				<img src="../../assets/pic_login_bg@2x.png">
			</div>
			<div class="login-right">
				<div class="login-form">
					<div class="login-title">
						欢迎登录<br>
						<span>
							河北省司法鉴定委托受理案件管理系统
						</span><br>
						<span>
							机构管理
						</span>
					</div>
					<div class="login-input">
						<el-input v-model="username" placeholder="请输入鉴定机构名称"></el-input>
					</div>
					<div class="login-input">
						<el-input v-model="password" placeholder="请输入登录密码" show-password></el-input>
					</div>
					<div class="login-button">
						<el-button type="button" :loading="noRepeat" @click="doLogin">立即登录</el-button>
					</div>
					<div class="login-support">
						<div>技术支持：北京中经天平科技有限公司</div>
						<!-- <a href="">京公网安备11000002000001号</a> -->
						<a href="https://beian.miit.gov.cn/">冀ICP备2021002114号-1</a>
						<a href="">©2021 河北司法鉴定协会</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'login',
		data() {
			return {
				username: '',
				password: '',
				nameError: true,
				nameErrorMsg: '',
				passError: true,
				passErrorMsg: '',
				noRepeat: false
			};
		},
		methods: {
			...mapMutations(['login', 'saveUserinfo']),
			doLogin() {
				if (this.username == '') {
					this.$message.error('请输入账号。');
					return
				}
				if (this.password == '') {
					this.$message.error('请输入密码。');
					return
				}
				this.noRepeat = true
				localStorage.clear()
				this.$api.login({
					'username': this.username,
					'password': this.password,
					'loginType': 2
				}, res => {
					if (res && res.code == 200) {
						this.login(res.data.token)
						let userinfo = {
							avatar: res.data.headImg == null ? '' : res.data.headImg,
							name: res.data.realName,
							org: res.data.organNo
						}
						this.saveUserinfo(userinfo)
						this.$notify({
							title: '成功',
							message: '登录成功，即将为您跳转。',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.noRepeat = false
								this.$router.push({
									path: '/layout'
								})
							}
						});
					} else {
						this.noRepeat = false
					}
				})
			},
			keydownMethod(){
				this.doLogin()
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			localStorage.clear()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.login-box {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 1;
		background: #e8eaef;
		display: flex;
		justify-content: center;
		align-items: center;

		.login-content {
			width: 900px;
			height: 560px;
			background: #FFFFFF;
			border-radius: 18px;
			overflow: hidden;
			display: flex;
			justify-content: space-between;

			.login-left {
				width: 272px;
				height: 100%;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.login-right {
				width: 628px;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				position: relative;

				.login-form {
					width: 400px;
					margin-left: 140px;

					.login-title {
						width: 100%;
						font-size: 22px;
						color: #464F6D;
						font-weight: bold;
						line-height: 30px;

						span {
							font-size: 18px;
						}
					}

					.login-input,
					.login-button,
					.login-support {
						width: 100%;
						height: 40px;
						margin: 15px 0px;

						.el-button {
							width: 100%;
							height: 100%;
							background: #464F6D;
							color: #FFFFFF;
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: 16px;
							border-radius: 4px;
							border: none;
						}

						.el-select {
							width: 260px;
						}

						.el-input {
							width: 260px;
						}
					}

					.login-button {
						width: 260px;
						margin-top: 40px;
					}

					.login-support {
						width: 440px;
						font-size: 12px;
						color: #828DA3;
						display: flex;
						justify-content: space-between;
						margin-top: 30px;
						flex-wrap: wrap;
						margin-left: -90px;
						padding: 0px 60px;
						box-sizing: border-box;

						div {
							width: 100%;
							height: 30px;
							display: flex;
							justify-content: center;
						}

						a {
							color: #828DA3;
						}

						a:hover {
							color: #007AFF;
						}
					}
				}

				.qrcode-box {
					width: 400px;

					.qrcode-title,
					.qrcode-image,
					.qrcode-refresh,
					.qrcode-hint,
					.qrcode-support {
						width: 100%;
						display: flex;
						justify-content: center;
					}

					.qrcode-title {
						height: 50px;
						color: #464F6D;
						font-size: 22px;
						font-weight: bold;
					}

					.qrcode-image {
						.qrcode-area {
							width: 160px;
							height: 160px;
							border: 1px solid #464F6D;
							box-sizing: border-box;

							img {
								width: 100%;
								height: 100%;
							}
						}
					}

					.qrcode-refresh {
						height: 50px;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #0000FF;
						margin-top: 10px;
						cursor: pointer;

						i {
							margin-right: 4px;
						}

						span {
							border-bottom: 1px solid #0000FF;
							padding: 4px 0px;
						}
					}

					.qrcode-hint {
						font-size: 13px;
						color: #464F6D;
						line-height: 28px;
						text-align: center;
					}

					.qrcode-support {
						font-size: 12px;
						color: #828DA3;
						margin-top: 20px;
					}
				}

				.qrcode-back {
					position: absolute;
					right: 15px;
					bottom: 15px;
					z-index: 9;
					height: 50px;
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #0000FF;
					cursor: pointer;

					i {
						font-size: 20px;
					}

					span {
						margin-left: 4px;
						padding: 4px 0px;
						border-bottom: 1px solid #0000FF;
					}
				}
			}
		}
	}
</style>
